import Vue from 'vue'
import App from './App.vue'
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import http from '@/api/config';
import move from './tools/move';
import {Base64} from 'js-base64';
import Meta from 'vue-meta';
// 使用vue-meta
Vue.use(Meta);
Vue.use(Base64);
Vue.use(ElementUI);
Vue.config.errorHandler = (err, vm, info) => {
  console.log('');
}
Vue.prototype.$http = http;
Vue.prototype.$move = move;
Vue.config.productionTip = false;
Vue.config.warnHandler = function(msg, vm, trace) {
    console.log(`Warn: ${msg}\nTrace: ${trace}`);
  }
new Vue({
    router,
    render: h => h(App)
}).$mount('#app')